import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft, SearchX } from 'lucide-react';
import { Button, Card, EmptyState } from '@proerp/ui';
import { Page, PageHeader } from '@/components/AppShell';

/**
 * Unbekannte Adresse — sagt, was los ist, und bietet zwei Wege weiter
 * (erp-design-guideline §14). Vorher stand hier der Modul-Platzhalter
 * „wird als Nächstes umgesetzt".
 */
export function NotFoundPage() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  return (
    <Page>
      <PageHeader title="Seite nicht gefunden" />
      <Card>
        <EmptyState
          icon={SearchX}
          title="Diese Adresse gibt es nicht (mehr)"
          description={`„${pathname}" führt zu keiner Seite — vielleicht ein alter Lesezeichen-Link oder ein Tippfehler in der Adresse.`}
          action={
            <div className="flex flex-wrap justify-center gap-2">
              <Button variant="secondary" onClick={() => navigate(-1)}>
                <ArrowLeft className="h-4 w-4" strokeWidth={1.5} />
                Zurück
              </Button>
              <Button variant="primary" asChild>
                <Link to="/">Zum Dashboard</Link>
              </Button>
            </div>
          }
        />
      </Card>
    </Page>
  );
}
